export default __webpack_public_path__ + "static/media/require-mobile-device.e417b1b8.svg";